<template>
    <v-form v-bind="$attrs" @submit.prevent="on_submit" v-model="is_form_valid" @input="(v) => $emit('input', v)" ref="form">
        <transition name="collapsable">
            <div>
                <InvalidFormTitle v-if="!fields_are_valid || error_message" />
                <FormValidationError v-if="form_validation_error || error_message" @closed="on_close_error" class="form-validation-main-error">
                    {{form_validation_error ? form_validation_error : error_message}}
                </FormValidationError>
            </div>
        </transition>
        <!-- Pass on all named slots -->
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
        <!-- Pass on all scoped slots -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope" />
        </template>
    </v-form>
</template>
<script>
import l from 'lang';
import EventBus from 'event-bus/EventBus';
import FormValidationError from '../../elements/error-components/FormValidationError.vue';
import InvalidFormTitle from '../../elements/error-components/InvalidFormTitle.vue';

export default {
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        validation: {
            type: Array,
            required: false,
        },
        error_message: {
            type: String,
            required: false
        }
    },
    components: {
        InvalidFormTitle,
        FormValidationError,
    },
    data() {
        return {
            l,
            fields_are_valid: true,
            is_form_valid: this.$props.value,
            form_validation_error: null,
        };
    },
    created() {
        EventBus.$on('form_input_changed', () => {
            this.$emit('changed');
            this.$data.form_validation_error = null;
        });
    },
    methods: {
        on_close_error() {
            this.$data.form_validation_error = null
            this.$emit('on_close_error')
        },
        scroll_to_top() {
            const vue_modal = this.$refs.form.$el.closest('.default-modal-content');
            if (vue_modal) {
                return vue_modal.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            const react_modal = this.$refs.form.$el.closest("div[class*='MuiDialogContent-root']");
            if (react_modal) {
                return react_modal.scrollTo({ top: 0, behavior: 'smooth' });
            } 
            
            return window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        on_submit(e) {
            if (e) e.preventDefault();

            if (this.$refs.form.validate()) {
                this.$data.fields_are_valid = true;
            } else {
                this.$data.fields_are_valid = false;
                this.scroll_to_top();
                return null;
            }
            const form_validation_error = this.custom_validation();
            if (form_validation_error !== true) {
                this.scroll_to_top();
                this.$data.form_validation_error = form_validation_error;
                return null;
            }
            this.$data.form_validation_error = null;
            this.$data.fields_are_valid = true;
            EventBus.$emit('form_submitted');
            this.$emit('submit', e);
            return true;
        },
        custom_validation() {
            if (Array.isArray(this.$props.validation) && this.$props.validation.length) {
                for (let i = 0; i < this.$props.validation.length; i++) {
                    const is_valid = this.$props.validation[i]();
                    if (is_valid !== true) {
                        this.$emit('invalid_form', i);
                        return is_valid;
                    }
                }
            }
            return true;
        }
    },
    watch: {
        is_form_valid(v) {
            if (v) {
                this.$data.fields_are_valid = true;
            }
            this.$emit('input', v);
        },
        form_validation_error(v) {
            this.$emit('custom_validation', !!v);
        },
    }
};
</script>

<style lang="scss" scoped>
.form-validation-main-error {
    margin-bottom: 28px;
}
</style>
